import auth from '../../route/auth';

import { AUTH_LOGOUT } from '@/types/authTypes';

// Action Creator
export const logout = (data) => async (dispatch) => {
    try {
        const response = await auth.Logout(data);
        const payload = response?.data ? { data: response?.data, errorMessage: false } : { data: false, errorMessage: 'Users Not Found' };
        dispatch({ type: AUTH_LOGOUT, payload });
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message;
        dispatch({
            type: AUTH_LOGOUT,
            payload: { data: false, errorMessage }
        });
    }
};
